import React from 'react';
import { TestResultCard } from '../../atoms/testing/TestResultCard';

interface TestResult {
  id: number;
  scenario: string;
  status: 'passed' | 'failed';
  response: string;
  score: number;
  timestamp: string;
}

interface TestResultsListProps {
  results: TestResult[];
}

export const TestResultsList: React.FC<TestResultsListProps> = ({
  results,
}) => {
  return (
    <div className="space-y-4">
      {results.map((result) => (
        <TestResultCard
          key={result.id}
          scenario={result.scenario}
          status={result.status}
          response={result.response}
          score={result.score}
          timestamp={result.timestamp}
        />
      ))}
    </div>
  );
};
